<template>
  <div>
    <div
      :key="configDataForm.title + configDataForm.description"
      class="area-title-container"
      @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
      @mouseleave="handleShowOperationBtn(false)"
    >
      <span class="area-title-container-title">{{ configDataForm.title }}</span>

      <div class="area-title-container-bottom">
        <span class="area-title-container-bottom-line"></span>
        <span class="area-title-container-bottom-icon">
          <img :src="configDataForm.iconFullUrl || noUpload" fit="cover" />
        </span>
        <span class="area-title-container-bottom-line"></span>
      </div>

      <operation-container
        v-if="showOperationBtn && !showEditForm"
        :component-data="props.componentData"
        :show-edit-content-button="props.showEditContentButton"
        :show-edit-components-button="props.showEditComponentsButton"
        :show-delete-components-button="props.showDeleteComponentsButton"
        :show-insert-components-button="props.showInsertComponentsButton"
        :show-sort-components-button="props.showSortComponentsButton"
        @handle-show-edit-form="handleShowEditForm"
        @handle-change-components="handleChangeComponents"
        @handle-delete-components="handleDeleteComponents"
        @handle-insert-components="handleInsertComponents"
        @handle-sort-components="handleSortComponents"
      ></operation-container>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <area-title-edit-form
        v-if="showEditForm"
        v-model="configDataForm"
        :component-data="props.componentData"
        @handle-show-edit-form="handleShowEditForm"
        @handle-edit-components-content="handleEditComponentsContent"
      ></area-title-edit-form>
    </el-drawer>
  </div>
</template>
<script setup>
// #region 引用
import OperationContainer from '../common/OperationContainer.vue';
import AreaTitleEditForm from './AreaTitleEditFormTwo.vue';
// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量

// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
 query: '?url',
});
// 直接获取目标图片 URL
const noUpload = images['/src/assets/images/web/common/other/no-upload.png']?.default;

// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);
const configDataForm = ref({
  title: '示例中文标题',
  description: '实例英文标题',
});

if (props.componentData.configData) {
  configDataForm.value = JSON.parse(props.componentData.configData);
}

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};
/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};
/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // console.log('configDataForm--1:', configDataForm);
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataForm.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};

// #endregion
</script>
<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

/* PC端样式 */
@include pc {
  .area-title-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 120px;
    margin: 20px 0;

    span {
      display: inline-block;
    }
  }

  .area-title-container-bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .area-title-container-title {
    height: 60px;
    font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    color: #888;
  }

  .area-title-container-bottom-line {
    flex-grow: 1;
    width: 100%;
    border-bottom: 1px solid var(--el-color-grey-light-54);
  }

  .area-title-container-bottom-icon {
    margin: 0 28px;
    font-size: 16px;
    letter-spacing: 5px;
    img {
      width: 40px;
      height: 40px;
    }
  }
}

/* 移动端样式 */
@include mobile {
  .area-title-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 16vw;
    margin: 3vw 0;

    span {
      display: inline-block;
    }
  }

  .area-title-container-bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 4vw;
  }

  .area-title-container-title {
    height: 10vw;
    font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
    font-size: 5vw;
    font-style: normal;
    font-weight: 700;
    color: #888;
  }

  .area-title-container-bottom-line {
    flex-grow: 1;
    width: 100%;
    border-bottom: 1px solid var(--el-color-grey-light-54);
  }

  .area-title-container-bottom-icon {
    margin: 0 4vw;
    font-size: 3.5vw;
    letter-spacing: 2px;
    img {
      width: 8vw;
      height: 8vw;
    }
  }
}
</style>
